import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import API from "../api/config";
import {toast} from "react-hot-toast";
import Logo from "../assets/QRscriptsLogo1.png";

const UserLogin = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [loading, setLoading] = useState(false);
    const [codeSent, setCodeSent] = useState(false);

    const getCode = async () => {
        if (!email) return toast.error("Email required");

        try {
            setLoading(true);
            await API.post("/auth/request-otp", {email});
            setCodeSent(true);
        } catch (e) {
            toast.error(e.response?.data?.message || "Failed to send OTP");
        } finally {
            setLoading(false);
        }
    };

    const verifyCode = async () => {
        if (otp.length !== 5) return toast.error("Enter valid 5-digit OTP");

        try {
            setLoading(true);
            await API.post("/auth/verify-otp", {email, otp});
            localStorage.setItem("verified_email", email);
            navigate("/edit-registration");
        } catch (e) {
            toast.error(e.response?.data?.message || "Invalid OTP");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex flex-col bg-gradient-to-b from-pink-50 to-white">
            {/* ================= HEADER ================= */}
            <header className="bg-white border-b border-pink-100 shadow-sm">
                <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
                    {/* LEFT: Logo + Brand */}
                    <div className="flex items-center gap-4">
                        <a
                            href="https://www.qrscripts.in/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block hover:opacity-80 transition-opacity"
                        >
                            <div className="bg-pink-100 p-2 rounded-xl cursor-pointer">
                                <img src={Logo} alt="QR Scripts" className="h-10 w-auto" />
                            </div>
                        </a>
                        <div className="leading-tight">
                            <h1 className="bg-gradient-to-r from-pink-600 to-slate-900 bg-clip-text text-transparent font-extrabold text-xl">
                                QR Scripts
                            </h1>
                            <p className="text-slate-500 text-[10px] uppercase tracking-wider font-semibold">
                                Secure QR Ownership
                            </p>
                        </div>
                    </div>

                    {/* RIGHT: Links */}
                    <div className="hidden sm:flex items-center gap-6">
                        <nav className="flex gap-4 text-xs">
                            <a
                                href="https://www.qrscripts.in/privacy-policy"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-slate-500 hover:text-pink-600 transition-colors font-medium"
                            >
                                Privacy Policy
                            </a>
                            <a
                                href="https://www.qrscripts.in/terms-and-condition"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-slate-500 hover:text-pink-600 transition-colors font-medium"
                            >
                                Terms
                            </a>
                        </nav>
                    </div>
                </div>
            </header>

            {/* ================= MAIN CONTENT ================= */}
            <main className="flex-1 flex items-center justify-center px-4">
                <div className="w-full max-w-md bg-white rounded-3xl p-8 shadow-xl shadow-pink-500/30">
                    <h2 className="text-2xl font-bold text-pink-600 mb-2">Verify Ownership</h2>
                    <p className="text-sm text-gray-600 mb-6">
                        Enter your registration email to receive a verification code.
                    </p>

                    {/* EMAIL */}
                    <label className="text-xs font-semibold text-gray-500">REGISTRATION EMAIL</label>
                    <input
                        type="email"
                        value={email}
                        disabled={codeSent}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="you@example.com"
                        className="w-full border rounded-xl px-4 py-3 mt-2 mb-5
                     focus:outline-none focus:ring-2 focus:ring-pink-400"
                    />

                    {/* GET CODE */}
                    <button
                        onClick={getCode}
                        disabled={loading || codeSent}
                        className="w-full bg-pink-600 hover:bg-pink-700 text-white
                     rounded-xl py-3 font-semibold mb-6
                     disabled:opacity-50"
                    >
                        {loading ? "Sending…" : "Get Code"}
                    </button>

                    {/* OTP */}
                    <label className="text-xs font-semibold text-gray-500">ENTER 5-DIGIT CODE</label>
                    <input
                        value={otp}
                        disabled={!codeSent}
                        onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                        maxLength={5}
                        placeholder="12345"
                        className="w-full border rounded-xl px-4 py-3 mt-2 mb-5
                     text-center tracking-widest text-lg
                     focus:outline-none focus:ring-2 focus:ring-pink-400
                     disabled:bg-gray-100"
                    />

                    {/* VERIFY */}
                    <button
                        onClick={verifyCode}
                        disabled={!codeSent || loading}
                        className="w-full bg-gray-900 hover:bg-black text-white
                     rounded-xl py-3 font-semibold
                     disabled:opacity-50"
                    >
                        {loading ? "Verifying…" : "Verify & Edit Details"}
                    </button>
                </div>
            </main>

            {/* ================= FOOTER ================= */}
            <footer className="text-center py-4 text-xs text-gray-500">
                © {new Date().getFullYear()} QR Scripts · Secure QR Management
            </footer>
        </div>
    );
};

export default UserLogin;
